import { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { useDispatch } from "react-redux";

import { User } from "pwapi";

import {
  AreaCountAnnotation,
  ScaleInfo,
  ViewerMode,
  XYPoint,
} from "custom-models/ViewerTypes";

import { changeViewerMode } from "shared/actions/slideDetailActions";
import { createAreaCountAnnotation } from "shared/utils/annotations";

import ViewerFacade from "../ViewerFacade";

interface AreaCountToolProps {
  scaleInfo: ScaleInfo;
  viewerFacade: ViewerFacade;
  user: User;
  onAnnotationComplete: (ann: AreaCountAnnotation) => void;
}

const AreaCountTool = (props: AreaCountToolProps) => {
  const { scaleInfo, viewerFacade, user, onAnnotationComplete } = props;
  const dispatch = useDispatch();

  const [point, setPoint] = useState<XYPoint | null>(null);

  const labelRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const handlerId = props.viewerFacade.addHandler("canvas-click", (event) => {
      event.preventDefaultAction = true;

      const coords = props.viewerFacade.imageCoords(event);

      if (
        coords &&
        coords.x >= 0 &&
        coords.y >= 0 &&
        coords.x < scaleInfo.width &&
        coords.y < scaleInfo.height
      ) {
        setPoint({ x: coords.x, y: coords.y });
      }
    });
    return () => {
      viewerFacade?.removeHandler(handlerId);
    };
  }, []);

  const pixelsPerMeter = viewerFacade.getPixelsPerMeter();
  return (
    <>
      {point && pixelsPerMeter && (
        <circle
          key="AreaCountTool-circle"
          cx={point.x}
          cy={point.y}
          r={pixelsPerMeter / 1000 / Math.sqrt(Math.PI)}
          strokeWidth={2.0 / scaleInfo.scaleX}
          stroke="black"
          fill="none"
        />
      )}
      <Modal
        isOpen={!!point}
        onRequestClose={() => {
          setPoint(null);
        }}
        contentLabel="COUNT"
        className="Modal"
        overlayClassName="Overlay"
      >
        <div className="TextToolModal">
          <h3>ENTER COUNT:</h3>
          <div>
            <label htmlFor="cells-per-mm">Cells per square mm:</label>
            <input
              id="cells-per-mm"
              autoFocus={true}
              ref={labelRef}
              type="number"
              min={0}
            />
          </div>
          <nav>
            <button
              onClick={() => {
                const parsedVal = parseInt(
                  (labelRef.current?.value || "").trim()
                );
                const val = Number.isNaN(parsedVal) ? 0 : parsedVal;
                onAnnotationComplete(
                  createAreaCountAnnotation(
                    undefined,
                    "",
                    user,
                    null,
                    point,
                    `${val}`
                  )
                );
                setPoint(null);
                dispatch(changeViewerMode(ViewerMode.PAN_ZOOM));
              }}
            >
              OK
            </button>
            <button
              onClick={() => {
                setPoint(null);
              }}
            >
              CANCEL
            </button>
          </nav>
        </div>
      </Modal>
    </>
  );
};

export default AreaCountTool;
